import React, { Component } from "react";
import styled from "styled-components";
import LeftArrow from "src/img/left-arrow.png";
import RightArrow from "src/img/right-arrow.png";
import PreviewDisplay from "./FilteredPngStack";
import {
    MobilePreviewArrowButton,
    MobilePreviewArrowImage,
    MobilePreviewDot,
    MobilePreviewHeading
} from "src/components";
import { Screens } from "../../constants";

export function ScreenSwitch(param) {
    switch (param) {
    case Screens.MAIN:
        return "Main quotes screen";
    case Screens.QUOTES:
        return "Quote Fullscreen";
    case Screens.ARTICLES:
        return "Article Fullscreen";
    default:
        break;
    }
}

// Styled components
const FlexContainer = styled.div`
    display: flex;
    flex-direction: ${p => p.direction || "row"};
    align-items: center;
`;

const WidthContainer = styled.div`
    display: flex;
    flex-direction: ${p => p.direction || "row"};
    align-items: center;
    justify-content: center;
    height: ${p => p.height || "100%"};
    width: ${p => p.width || "auto"};
    padding: ${p => p.padding || "0"};
    margin-top: ${p => p.marginTop || "0"};
    position: ${p => p.position || "static"};
    min-height: ${p => p.minHeight || "auto"};
    box-sizing: ${p => p.boxSizing || "content-box"};
`;

class ImagePreview extends Component {
    renderDots(currentScreen, screenIds) {
        return screenIds.map((id, index) => (
            <MobilePreviewDot key={index} isHighlighted={id === currentScreen} />
        ));
    }

    render() {
        const {
            currentScreen,
            leftScreen,
            rightScreen,
            currentForm,
            imageWidth,
            screenIds,
            colourPalette,
            tempLogoUrl,
            assetLogoUrl,
            assetIconUrl,
            formData,
        } = this.props;

        const dots = this.renderDots(currentScreen, screenIds);
        const logoUrl = tempLogoUrl || assetLogoUrl;

        return (
            <FlexContainer>
                {/* Left arrow */}
                <WidthContainer>
                    <MobilePreviewArrowButton type="button" margin="0 1rem 0 0" onClick={leftScreen} aria-label="Previous preview screen">
                        <MobilePreviewArrowImage src={LeftArrow} alt="" aria-hidden="true" />
                    </MobilePreviewArrowButton>
                </WidthContainer>

                {/* Screen name and preview */}
                <div>
                    <MobilePreviewHeading size="25px">
                        Preview
                    </MobilePreviewHeading>
                    <MobilePreviewHeading size="16px" weight={700} margin="0 0 2rem">
                        {ScreenSwitch(currentScreen)}
                    </MobilePreviewHeading>
                    <WidthContainer width={imageWidth || "100%"} direction="column">
                        <WidthContainer width={"302px"} height={"614px"} direction="column" padding="40px"
                            boxSizing="border-box" position="relative" minHeight="500px">
                            <PreviewDisplay
                                currentForm={currentForm}
                                colourPalette={colourPalette}
                                currentScreen={currentScreen}
                                logoUrl={logoUrl}
                                iconUrl={assetIconUrl}
                                formData={formData}
                            />
                        </WidthContainer>

                        {/* Navigation dots */}
                        <WidthContainer width="100%" padding="8px">
                            <WidthContainer width="100%">
                                {dots}
                            </WidthContainer>
                        </WidthContainer>
                    </WidthContainer>
                </div>

                {/* Right arrow */}
                <WidthContainer>
                    <MobilePreviewArrowButton type="button" margin="0 0 0 1rem" onClick={rightScreen} aria-label="Next preview screen">
                        <MobilePreviewArrowImage src={RightArrow} alt="" aria-hidden="true" />
                    </MobilePreviewArrowButton>
                </WidthContainer>
            </FlexContainer>
        );
    }
}

export default ImagePreview;
